import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;

async function getMaster(payload) {
    const result = await axios.post(apiUrl + "/admin/dropdown/getmasters",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getUsers(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/getusers",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}
async function getPosition(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/viewposition",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function exitPosition(payload) {
    const result = await axios.post(apiUrl + "/closeposition",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function rollOver(payload) {
    const resultuser = await axios.post(apiUrl + "/trade/rollover",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function getPositionOnlyQty(payload) {
    const result = await axios.post(apiUrl + "/admin/viewposition/qty",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getPositionOnlyStatus(payload) {
    const result = await axios.post(apiUrl + "/admin/viewposition/status",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function updatePositionStatusToProcessed(payload) {
    const result = await axios.post(apiUrl + "/admin/viewposition/status/processed",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const PositionServices = {
    getMaster,
    getUsers,
    getPosition,
    rollOver,
    exitPosition,
    getPositionOnlyQty,
    getPositionOnlyStatus,
    updatePositionStatusToProcessed
}